/**
 * The star toggle - favoriting a company, wherever a company appears.
 *
 * A single small component rather than inlined at each call site: the
 * registry row and the company profile header both need the same pending/
 * error handling around `useFavorites().toggle()`, and duplicating that
 * logic is how the two would eventually drift.
 */

import { useFavorites } from '../lib/favorites-context.jsx';
import { IconStar } from './Icons.jsx';

export default function FavoriteStar({ companyNumber, size = 'sm', className = '' }) {
  const { has, isPending, toggle } = useFavorites();
  const isFavorite = has(companyNumber);
  const pending = isPending(companyNumber);

  return (
    <button
      type="button"
      className={`btn btn-ghost btn-icon${size === 'sm' ? ' btn-sm' : ''} favorite-star${
        isFavorite ? ' is-favorite' : ''
      } tip tip-below ${className}`}
      disabled={pending}
      onClick={(event) => {
        // The star sits inside clickable rows (a master-item, a card) in more
        // than one place - it must never also trigger the row's own onClick.
        event.stopPropagation();
        void toggle(companyNumber, isFavorite);
      }}
      data-tip={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
      aria-label={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
      aria-pressed={isFavorite}
    >
      {pending ? <span className="spinner" /> : <IconStar filled={isFavorite} />}
    </button>
  );
}
